<template>
  <div class="app-container">
    <!-- 工具栏 -->
    <div class="filter-container">
      <!-- 计算维度-->
      <div class="filter-data">
        <div class="label filter-item">计算维度：</div>
        <el-radio-group class="filter-item" v-model="queryType" size="small" @change="getHeaderList">
          <el-radio-button :label="3">设备</el-radio-button>
          <el-radio-button :label="2">账号</el-radio-button>
          <el-radio-button :label="1">角色</el-radio-button>
        </el-radio-group>
      </div>

      <!-- 分析粒度 -->
      <div class="filter-data">
        <div class="label filter-item">分析粒度：</div>
        <el-radio-group class="filter-item" v-model="dateType" size="small" @change="getHeaderList">
          <el-radio-button label="day">分天</el-radio-button>
          <el-radio-button label="month">分月</el-radio-button>
          <el-radio-button label="all">汇总</el-radio-button>
        </el-radio-group>

        <el-date-picker  unlink-panels v-if="dateType === 'day' || dateType === 'all'" class="dataPicker filter-item" :clearable="false" size="small" v-model="dayTimes" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="daterange"
          range-separator="-" :picker-options="pickerOptions" start-placeholder="开始日期" end-placeholder="结束日期" @change="getHeaderList" style="width:260px"></el-date-picker>

        <el-date-picker  unlink-panels v-else class="dataPicker filter-item" :clearable="false" size="small" v-model="monthTimes" format="yyyy-MM" value-format="yyyy-MM" type="monthrange" range-separator="-"
          :picker-options="pickerMonthOptions" start-placeholder="开始日期" end-placeholder="结束日期" @change="getHeaderList" style="width:260px"></el-date-picker>
      </div>

      <!--分析维度 -->
      <div class="filter-data" style="display:inline-flex">
        <div class="label filter-item">分析维度：</div>
        <el-checkbox-group class="filter-item" v-model="groupBy" size="small" @change="getHeaderList">
          <el-checkbox-button v-for="item in groupByOptions" :key="item.value" :label="item.value" :disabled="groupBy.length >= 3 && groupBy.indexOf(item.value) == -1">{{item.title}}</el-checkbox-button>
        </el-checkbox-group>

        <el-button class="filter-item" size="small" type="primary" plain icon="el-icon-download" @click="isOpenMore = true" v-if="!isOpenMore">高级</el-button>
        <el-button class="filter-item" size="small" type="primary" plain icon="el-icon-upload2" @click="isOpenMore = false" v-else>关闭</el-button>
      </div>

      <!-- 筛选 -->
      <div class="filter-data" v-if="isOpenMore">
        <div class="label filter-item">筛&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;选：</div>
        <el-select class="filter-item" size="small" v-model="appkeys" multiple collapse-tags filterable clearable placeholder="项目" style="width:200px;">
          <el-option v-for="item in gameOptions" :key="item.appkey" :label="item.name" :value="item.appkey"></el-option>
        </el-select>

        <el-select class="filter-item" size="small" v-model="types" multiple collapse-tags filterable clearable placeholder="来源" style="width:150px;">
          <el-option v-for="item in typesOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>

        <!-- <el-select class="filter-item" size="small" v-model="media" multiple collapse-tags filterable clearable placeholder="媒体" style="width:190px;">
          <el-option v-for="item in mediaOptions" :key="item.channelCode" :label="item.name" :value="item.channelCode"></el-option>
        </el-select> -->
        <el-cascader v-model="media" :options="mediaOptions" size="small" collapse-tags filterable clearable placeholder="媒体" :props="{ expandTrigger: 'hover' ,multiple: true}"
          style="width:260px;margin-top:-7px;margin-right:15px"></el-cascader>

        <el-select class="filter-item" size="small" v-model="client_os" multiple collapse-tags filterable clearable placeholder="平台" style="width:150px;">
          <el-option v-for="item in client_osOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>

        <el-select class="filter-item" size="small" v-model="advertiserIds" multiple collapse-tags filterable :filter-method="filterAdvertiserIds" :reserve-keyword="true" clearable placeholder="媒体账号"
          @visible-change="getFilterData($event,'advertiser_id')" style="width:200px;">
          <el-option v-for="item in advertiserIdsOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>

        <el-select class="filter-item" size="small" v-model="campaignIds" multiple collapse-tags filterable :filter-method="filterCampaignIds" :reserve-keyword="true" clearable placeholder="广告组"
          @visible-change="getFilterData($event,'campaign_id')" style="width:200px;">
          <el-option v-for="item in campaignIdsOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>

        <el-select class="filter-item" size="small" v-model="adIds" multiple collapse-tags filterable :filter-method="filterAdIds" :reserve-keyword="true" clearable placeholder="广告计划"
          @visible-change="getFilterData($event,'ad_id')" style="width:200px;">
          <el-option v-for="item in adIdsOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>

        <el-select class="filter-item" size="small" v-model="creativeIds" multiple collapse-tags filterable :filter-method="filterCreativeIds" :reserve-keyword="true" clearable placeholder="广告创意"
          @visible-change="getFilterData($event,'creative_id')" style="width:200px;">
          <el-option v-for="item in creativeIdsOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>

        <el-date-picker class="dataPicker filter-item" :clearable="false" size="small" v-model="dayTimes" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="daterange" range-separator="-" :picker-options="pickerOptions"
          start-placeholder="开始日期" end-placeholder="结束日期" style="width:260px"></el-date-picker>

        <el-button class="filter-item" size="small" icon="el-icon-circle-plus-outline" @click="addduibitiaojian">添加对比</el-button>
      </div>

      <div class="filter-data" v-show="isOpenMore" v-for="(dlist,dlistindex) in duibilist" :key="dlistindex">
        <div class="label filter-item">对比筛选{{dlistindex+1}}：</div>
        <el-select class="filter-item" size="small" v-model="dlist.appkeys" multiple collapse-tags filterable clearable placeholder="项目" style="width:200px;">
          <el-option v-for="item in gameOptions" :key="item.appkey" :label="item.name" :value="item.appkey"></el-option>
        </el-select>

        <el-select class="filter-item" size="small" v-model="dlist.types" multiple collapse-tags filterable clearable placeholder="来源" style="width:150px;">
          <el-option v-for="item in typesOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>

        <!-- <el-select class="filter-item" size="small" v-model="dlist.media" multiple collapse-tags filterable clearable placeholder="媒体" style="width:190px;">
          <el-option v-for="item in mediaOptions" :key="item.channelCode" :label="item.name" :value="item.channelCode"></el-option>
        </el-select> -->

        <el-cascader v-model="dlist.media" :options="mediaOptions" size="small" collapse-tags filterable clearable placeholder="媒体" :props="{ expandTrigger: 'hover' ,multiple: true}"
          style="width:260px;margin-top:-7px;margin-right:15px"></el-cascader>

        <el-select class="filter-item" size="small" v-model="dlist.client_os" multiple collapse-tags filterable clearable placeholder="平台" style="width:150px;">
          <el-option v-for="item in client_osOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>

        <el-select class="filter-item" size="small" v-model="dlist.advertiserIds" multiple collapse-tags filterable :filter-method="filterAdvertiserIds" :reserve-keyword="true" clearable placeholder="媒体账号"
          @visible-change="getFilterData($event,'advertiser_id')" style="width:200px;">
          <el-option v-for="item in advertiserIdsOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>

        <el-select class="filter-item" size="small" v-model="dlist.campaignIds" multiple collapse-tags filterable :filter-method="filterCampaignIds" :reserve-keyword="true" clearable placeholder="广告组"
          @visible-change="getFilterData($event,'campaign_id')" style="width:200px;">
          <el-option v-for="item in campaignIdsOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>

        <el-select class="filter-item" size="small" v-model="dlist.adIds" multiple collapse-tags filterable :filter-method="filterAdIds" :reserve-keyword="true" clearable placeholder="广告计划"
          @visible-change="getFilterData($event,'ad_id')" style="width:200px;">
          <el-option v-for="item in adIdsOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>

        <el-select class="filter-item" size="small" v-model="dlist.creativeIds" multiple collapse-tags filterable :filter-method="filterCreativeIds" :reserve-keyword="true" clearable placeholder="广告创意"
          @visible-change="getFilterData($event,'creative_id')" style="width:200px;">
          <el-option v-for="item in creativeIdsOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>

        <el-date-picker class="dataPicker filter-item" :clearable="false" size="small" v-model="dayTimes" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="daterange" range-separator="-" :picker-options="pickerOptions"
          start-placeholder="开始日期" end-placeholder="结束日期" style="width:260px"></el-date-picker>

        <el-button class="filter-item" size="small" icon="el-icon-circle-plus-outline" @click="addduibitiaojian">添加对比</el-button>
        <el-button class="filter-item" style="padding:0px;font-size:24px" size="small" type="text" icon="el-icon-circle-close" @click="deleteduibitiaojian($event,dlistindex)"></el-button>
      </div>

      <!--数据筛选 -->
      <!-- <div class="filter-data" style="display:inline-flex" v-if="isOpenMore">
        <div class="label filter-item">数据筛选：</div>
        <el-select class="filter-item" size="small" v-model="norm" filterable clearable placeholder="效果指标" style="width:180px;">
          <el-option v-for="item in normOptions" :key="item.value" :label="item.title" :value="item.value"></el-option>
        </el-select>

        <el-select class="filter-item" size="small" v-model="symbol" filterable clearable placeholder="符号" style="width:180px;">
          <el-option v-for="item in symbolOptions" :key="item" :label="item" :value="item"></el-option>
        </el-select>

        <el-input class="filter-item" size="small" v-model="normValue" clearable placeholder="指标数值" style="width:180px;"></el-input>
      </div> -->
      <!-- 查询 -->
      <div class="filter-data" style="display:inline-flex; margin-left:0">
        <el-button class="filter-item" size="small" type="primary" icon="el-icon-search" @click="handleFilter">查询</el-button>
      </div>

    </div>

    <!-- 数据图标总览 -->
    <el-card class="box-card" shadow="never">
      <div slot="header" class="clearfix">
        <span style="line-height: 28px;">数据总览</span>
        <div class="right-box" style="float:right">
          <!-- <el-switch v-model="onlyBdc" active-text="只看BDC" inactive-text="" @change="handleFilter" style="margin: 0 10px"></el-switch> -->
          <!-- <el-switch v-model="notNull" active-text="过滤空数据" inactive-text="" @change="handleFilter" style="margin: 0 10px"></el-switch> -->
          <el-button size="mini" type="primary" @click="bianjilie" style="margin: 0 10px">编辑列</el-button>
          <el-button size="mini" type="primary" @click="handleEditNorm" style="margin: 0 10px">编辑指标</el-button>
          <!-- <el-button size="mini" type="primary"><i  class="el-icon-download"></i></el-button> -->
        </div>

      </div>
      <!-- 表格 -->
      <el-table class="grayTableTile" size="mini" v-loading="listLoading" :data="tableData1.records.result" border :summary-method="getSummaries" show-summary empty-text="待查询" @sort-change="handleAgeSortChange">
        <el-table-column v-for="(itemtable,index) in tableData1.headers" :key="itemtable.id" :label="itemtable.label" :property="itemtable.property" :fixed="index==0" :min-width="itemtable.whidth"
          :sortable="itemtable.sortFlag ? 'custom' : false">
          <el-table-column v-for="(itemtable1) in itemtable.children" :key="itemtable1.id" :label="itemtable1.label" :property="itemtable1.property" :min-width="itemtable1.whidth"
            :sortable="itemtable1.sortFlag ? 'custom' : false">
          </el-table-column>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <!-- <pagination v-show="total>0" :total="total" :page.sync="listQuery.pageNo" :limit.sync="listQuery.pageSize" @pagination="getList" style="margin-top:0" /> -->

    </el-card>

    <el-table style="margin-top:40px" class="grayTableTile" size="mini" v-loading="listLoading" :data="tableData2.records.result" border :summary-method="getSummaries" show-summary empty-text="待查询"
      @sort-change="handleAgeSortChange">
      <el-table-column width="35px"><i class="el-icon-circle-plus-outline"></i></el-table-column>
      <el-table-column v-for="(itemtable) in tableData2.headers" :key="itemtable.id" :label="itemtable.label" :property="itemtable.property" :min-width="itemtable.whidth"
        :sortable="itemtable.sortFlag ? 'custom' : false">
        <el-table-column v-for="(itemtable1) in itemtable.children" :key="itemtable1.id" :label="itemtable1.label" :property="itemtable1.property" :min-width="itemtable1.whidth"
          :sortable="itemtable1.sortFlag ? 'custom' : false">
        </el-table-column>
      </el-table-column>
    </el-table>

    <el-table style="margin-top:40px" class="grayTableTile" size="mini" row-key="id" :tree-props="{children: 'children', hasChildren: 'hasChildren'}" v-loading="listLoading" :data="tableData3.records.result" border
      :summary-method="getSummaries" show-summary empty-text="待查询" @sort-change="handleAgeSortChange">
      <el-table-column v-for="(itemtable) in tableData3.headers" :key="itemtable.id" :label="itemtable.label" :property="itemtable.property" :min-width="itemtable.whidth"
        :sortable="itemtable.sortFlag ? 'custom' : false">
      </el-table-column>
    </el-table>

    <el-table style="margin-top:40px" class="grayTableTile" size="mini" row-key="id" :tree-props="{children: 'children', hasChildren: 'hasChildren'}" v-loading="listLoading" :data="tableData4.records.result" border
      :summary-method="getSummaries" show-summary empty-text="待查询" @sort-change="handleAgeSortChange">
      <el-table-column v-for="(itemtable) in tableData4.headers" :key="itemtable.id" :label="itemtable.label" :property="itemtable.property" :min-width="itemtable.whidth"
        :sortable="itemtable.sortFlag ? 'custom' : false">
        <el-table-column v-for="(itemtable1) in itemtable.children" :key="itemtable1.id" :label="itemtable1.label" :property="itemtable1.property" :min-width="itemtable1.whidth"
          :sortable="itemtable1.sortFlag ? 'custom' : false">
        </el-table-column>
      </el-table-column>
    </el-table>

    <el-table style="margin-top:40px" class="grayTableTile" size="mini" v-loading="listLoading" :data="tableData.records.result" border :summary-method="getSummaries" show-summary empty-text="待查询"
      @sort-change="handleAgeSortChange">
      <el-table-column v-for="(itemtable,index) in tableData.headers" :key="itemtable.id" :label="itemtable.label" :property="itemtable.property" :fixed="index==0" :min-width="itemtable.whidth"
        :sortable="itemtable.sortFlag ? 'custom' : false">
      </el-table-column>
    </el-table>

    <!-- 编辑指标 -->
    <norm-filter ref="norm" :sourceData="recordsList" @handleSave="quedingshaixuan"></norm-filter>

    <el-dialog title="编辑列" :visible.sync="dialogVisible" width="500px">
      <div>
        <el-input value="游戏" readonly style="width:100px" size="mini"></el-input>
        <el-switch style="border:1px solid #dedede;padding:13px 5px;border-radius:5px;margin-top:-3px" v-model="value11" active-color="#13ce66" inactive-color="#ff4949" active-text="显示" inactive-text="隐藏">
        </el-switch>
        <el-switch style="border:1px solid #dedede;padding:13px 5px;border-radius:5px;margin-top:-3px" v-model="value12" active-color="#13ce66" inactive-color="#ff4949" active-text="横排" inactive-text="竖排">
        </el-switch>
      </div>
      <div style="margin-top:5px">
        <el-input value="媒体" readonly style="width:100px" size="mini"></el-input>
        <el-switch style="border:1px solid #dedede;padding:13px 5px;border-radius:5px;margin-top:-3px" v-model="value21" active-color="#13ce66" inactive-color="#ff4949" active-text="显示" inactive-text="隐藏">
        </el-switch>
        <el-switch style="border:1px solid #dedede;padding:13px 5px;border-radius:5px;margin-top:-3px" v-model="value22" active-color="#13ce66" inactive-color="#ff4949" active-text="横排" inactive-text="竖排">
        </el-switch>
      </div>
      <div style="margin-top:5px">
        <el-input value="平台" readonly style="width:100px" size="mini"></el-input>
        <el-switch style="border:1px solid #dedede;padding:13px 5px;border-radius:5px;margin-top:-3px" v-model="value31" active-color="#13ce66" inactive-color="#ff4949" active-text="显示" inactive-text="隐藏">
        </el-switch>
        <el-switch style="border:1px solid #dedede;padding:13px 5px;border-radius:5px;margin-top:-3px" v-model="value32" active-color="#13ce66" inactive-color="#ff4949" active-text="横排" inactive-text="竖排">
        </el-switch>
      </div>
      <div style="margin-top:5px">
        <el-input value="时间" readonly style="width:100px" size="mini"></el-input>
        <el-switch style="border:1px solid #dedede;padding:13px 5px;border-radius:5px;margin-top:-3px" v-model="value41" active-color="#13ce66" inactive-color="#ff4949" active-text="显示" inactive-text="隐藏">
        </el-switch>
        <el-switch style="border:1px solid #dedede;padding:13px 5px;border-radius:5px;margin-top:-3px" v-model="value42" active-color="#13ce66" inactive-color="#ff4949" active-text="横排" inactive-text="竖排">
        </el-switch>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import { find_records, find_groupBy, find_target, find_condition, find_recordsHeader, sync_headerData, find_recordsPreloading, find_CommonChannel,ajax_filterGame } from '@Sys~/api/sys'
import NormFilter from './components/normFilter'
import Store from '@Sys~/store'
const name = Store.getters.currentRoute.name
export default {
  name:name,
  components: { Pagination, NormFilter },
  data() {
    return {

      value11: true,
      value12: false,
      value21: true,
      value22: false,
      value31: true,
      value32: false,
      value41: true,
      value42: true,



      dialogVisible: false,
      isOpenMore: false, // 是否显示更多筛选

      queryType: 3, // 计算维度

      dateType: 'day', // 时间范围筛选 天:day, 月：month, all:汇总

      dayTimes: [new Date(new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 7)).Format("yyyy-MM-dd"), new Date(new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 1)).Format("yyyy-MM-dd")],
      monthTimes: [new Date().Format("yyyy-MM"), new Date().Format("yyyy-MM")],

      tableheaders: [],
      // 时间范围 快捷键
      pickerOptions: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              console.log(picker)
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime());
              picker.$emit('pick', [start, end]);
            }
          },

          {
            text: '昨天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '过去7天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '过去14天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 14);
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '过去30天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit('pick', [start, end]);
            }
          }
        ],
        // 当前日期之前的日期不可选
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      // 时间范围 月份 
      pickerMonthOptions: {
        // 当前日期之前的日期不可选
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },

      groupBy: [], // 分析维度
      groupByOptions: [],

      duibilist: [
      ],

      duibidata: {
        appkeys: [], // 当前游戏
        gameOptions: [], // 游戏列表

        media: [], // 当前媒体
        mediaOptions: [], // 媒体列表

        client_os: [], // 当前平台
        client_osOptions: [{ id: 1, name: 'Android' }, { id: 2, name: 'Ios' }], // 平台列表

        advertiserIds: [], // 当前媒体
        advertiserIdsOptions: [], // 媒体列表
        advertiserIdsOptionsAll: [], // 媒体列表总数据

        campaignIds: [], // 当前广告组
        campaignIdsOptions: [], // 广告组列表
        campaignIdsOptionsAll: [], // 广告组列表总数据

        adIds: [], // 当前广告计划
        adIdsOptions: [], // 广告计划列表
        adIdsOptionsAll: [], // 广告计划列表总数据

        creativeIds: [], // 当前广告创意
        creativeIdsOptions: [], // 广告创意列表
        creativeIdsOptionsAll: [], // 广告创意列表总数据
      },


      appkeys: [], // 当前游戏
      gameOptions: [], // 游戏列表

      media: [], // 当前媒体
      mediaOptions: [], // 媒体列表

      client_os: [], // 当前平台
      client_osOptions: [{ id: 1, name: 'Android' }, { id: 2, name: 'Ios' }], // 平台列表

      advertiserIds: [], // 当前媒体
      advertiserIdsOptions: [], // 媒体列表
      advertiserIdsOptionsAll: [], // 媒体列表总数据

      campaignIds: [], // 当前广告组
      campaignIdsOptions: [], // 广告组列表
      campaignIdsOptionsAll: [], // 广告组列表总数据

      adIds: [], // 当前广告计划
      adIdsOptions: [], // 广告计划列表
      adIdsOptionsAll: [], // 广告计划列表总数据

      creativeIds: [], // 当前广告创意
      creativeIdsOptions: [], // 广告创意列表
      creativeIdsOptionsAll: [], // 广告创意列表总数据

      norm: '', // 当前指标
      normOptions: [], // 指标列表
      symbol: '', // 符号
      symbolOptions: ['=', '!=', '<', '>', '>=', '<='], // 符合列表
      normValue: '',// 指标数值

      typesOptions: [{ id: 1, name: 'BDC' }, { id: 0, name: '其他' }],
      types: [],
      // onlyBdc: true, // 是否只看BDC
      // notNull: false, // 过滤空数据

      listLoading: false,
      tableData1: {
        headers: [{
          label: "游戏",
          property: "gamename",
          sortFlag: false,
          whidth: 95,
        },
        {
          label: "媒体",
          property: "meiti",
          sortFlag: false,
          whidth: 95,
        },
        {
          label: "平台",
          property: "pingtai",
          sortFlag: false,
          whidth: 95,
        },
        {
          label: "2020-10-21",
          property: "2020-10-21",
          sortFlag: false,
          whidth: 95,
          children: [
            {
              label: "新增角色",
              property: "2020-10-21xinzengjuese",
              sortFlag: false,
              whidth: 95,
            },
            {
              label: "活跃角色",
              property: "2020-10-21huoyuejuese",
              sortFlag: false,
              whidth: 95,
            },
            {
              label: "付费金额",
              property: "2020-10-21fufeijine",
              sortFlag: false,
              whidth: 95,
            }
          ]
        },
        {
          label: "2020-10-22",
          property: "2020-10-22",
          sortFlag: false,
          whidth: 95,
          children: [
            {
              label: "新增角色",
              property: "2020-10-22xinzengjuese",
              sortFlag: false,
              whidth: 95,
            },
            {
              label: "活跃角色",
              property: "2020-10-22huoyuejuese",
              sortFlag: false,
              whidth: 95,
            },
            {
              label: "付费金额",
              property: "2020-10-22fufeijine",
              sortFlag: false,
              whidth: 95,
            }
          ]
        },
        {
          label: "2020-10-23",
          property: "2020-10-23",
          sortFlag: false,
          whidth: 95,
          children: [
            {
              label: "新增角色",
              property: "2020-10-23xinzengjuese",
              sortFlag: false,
              whidth: 95,
            },
            {
              label: "活跃角色",
              property: "2020-10-23huoyuejuese",
              sortFlag: false,
              whidth: 95,
            },
            {
              label: "付费金额",
              property: "2020-10-23fufeijine",
              sortFlag: false,
              whidth: 95,
            }
          ]
        }],
        records: {
          result: [{
            "gamename": "绿色征途",
            "meiti": "目标组",
            "pingtai": "目标组",
            "2020-10-21xinzengjuese": "1234",
            "2020-10-21huoyuejuese": "456",
            "2020-10-21fufeijine": "789",
            "2020-10-22xinzengjuese": "1234",
            "2020-10-22huoyuejuese": "456",
            "2020-10-22fufeijine": "789",
            "2020-10-23xinzengjuese": "1234",
            "2020-10-23huoyuejuese": "456",
            "2020-10-23fufeijine": "789",
          }, {
            "gamename": "绿色征途",
            "meiti": "广点通",
            "pingtai": "Android",
            "2020-10-21xinzengjuese": "1234",
            "2020-10-21huoyuejuese": "456",
            "2020-10-21fufeijine": "789",
            "2020-10-22xinzengjuese": "1234",
            "2020-10-22huoyuejuese": "456",
            "2020-10-22fufeijine": "789",
            "2020-10-23xinzengjuese": "1234",
            "2020-10-23huoyuejuese": "456",
            "2020-10-23fufeijine": "789",
          }, {
            "gamename": "绿色征途",
            "meiti": "快手",
            "pingtai": "Android",
            "2020-10-21xinzengjuese": "1234",
            "2020-10-21huoyuejuese": "456",
            "2020-10-21fufeijine": "789",
            "2020-10-22xinzengjuese": "1234",
            "2020-10-22huoyuejuese": "456",
            "2020-10-22fufeijine": "789",
            "2020-10-23xinzengjuese": "1234",
            "2020-10-23huoyuejuese": "456",
            "2020-10-23fufeijine": "789",
          },]
        }
      },
      tableData2: {
        headers: [{
          label: "游戏",
          property: "gamename",
          sortFlag: false,
          whidth: 95,
        },
        {
          label: "对比组",
          property: "meiti",
          sortFlag: false,
          whidth: 95,
        },
        {
          label: "2020-10-21",
          property: "2020-10-21",
          sortFlag: false,
          whidth: 95,
          children: [
            {
              label: "新增角色",
              property: "2020-10-21xinzengjuese",
              sortFlag: false,
              whidth: 95,
            },
            {
              label: "活跃角色",
              property: "2020-10-21huoyuejuese",
              sortFlag: false,
              whidth: 95,
            },
            {
              label: "付费金额",
              property: "2020-10-21fufeijine",
              sortFlag: false,
              whidth: 95,
            }
          ]
        },
        {
          label: "2020-10-22",
          property: "2020-10-22",
          sortFlag: false,
          whidth: 95,
          children: [
            {
              label: "新增角色",
              property: "2020-10-22xinzengjuese",
              sortFlag: false,
              whidth: 95,
            },
            {
              label: "活跃角色",
              property: "2020-10-22huoyuejuese",
              sortFlag: false,
              whidth: 95,
            },
            {
              label: "付费金额",
              property: "2020-10-22fufeijine",
              sortFlag: false,
              whidth: 95,
            }
          ]
        },
        {
          label: "2020-10-23",
          property: "2020-10-23",
          sortFlag: false,
          whidth: 95,
          children: [
            {
              label: "新增角色",
              property: "2020-10-23xinzengjuese",
              sortFlag: false,
              whidth: 95,
            },
            {
              label: "活跃角色",
              property: "2020-10-23huoyuejuese",
              sortFlag: false,
              whidth: 95,
            },
            {
              label: "付费金额",
              property: "2020-10-23fufeijine",
              sortFlag: false,
              whidth: 95,
            }
          ]
        }],
        records: {
          result: [{
            "gamename": "绿色征途",
            "meiti": "目标组",
            "pingtai": "目标组",
            "2020-10-21xinzengjuese": "1234",
            "2020-10-21huoyuejuese": "456",
            "2020-10-21fufeijine": "789",
            "2020-10-22xinzengjuese": "1234",
            "2020-10-22huoyuejuese": "456",
            "2020-10-22fufeijine": "789",
            "2020-10-23xinzengjuese": "1234",
            "2020-10-23huoyuejuese": "456",
            "2020-10-23fufeijine": "789",
          }, {
            "gamename": "绿色征途",
            "meiti": "对比组1",
            "pingtai": "Android",
            "2020-10-21xinzengjuese": "1234",
            "2020-10-21huoyuejuese": "456",
            "2020-10-21fufeijine": "789",
            "2020-10-22xinzengjuese": "1234",
            "2020-10-22huoyuejuese": "456",
            "2020-10-22fufeijine": "789",
            "2020-10-23xinzengjuese": "1234",
            "2020-10-23huoyuejuese": "456",
            "2020-10-23fufeijine": "789",
          }, {
            "gamename": "绿色征途",
            "meiti": "对比组2",
            "pingtai": "Android",
            "2020-10-21xinzengjuese": "1234",
            "2020-10-21huoyuejuese": "456",
            "2020-10-21fufeijine": "789",
            "2020-10-22xinzengjuese": "1234",
            "2020-10-22huoyuejuese": "456",
            "2020-10-22fufeijine": "789",
            "2020-10-23xinzengjuese": "1234",
            "2020-10-23huoyuejuese": "456",
            "2020-10-23fufeijine": "789",
          },]
        }
      },
      tableData3: {
        headers: [{
          label: "指标",
          property: "gamename",
          sortFlag: false,
          whidth: 95,
        },
        {
          label: "2020-10-21",
          property: "2020-10-21",
          sortFlag: false,
          whidth: 95,
        },
        {
          label: "2020-10-22",
          property: "2020-10-22",
          sortFlag: false,
          whidth: 95,
        },
        {
          label: "2020-10-23",
          property: "2020-10-23",
          sortFlag: false,
          whidth: 95,
        }],
        records: {
          result: [{
            id: 3,
            gamename: 'LTV',
            "2020-10-21": 789,
            "2020-10-22": 123,
            "2020-10-23": 456,
            children: [{
              id: 31,
              gamename: '对比组1',
              "2020-10-21": 789,
              "2020-10-22": 123,
              "2020-10-23": 456
            }, {
              id: 32,
              gamename: '对比组2',
              "2020-10-21": 789,
              "2020-10-22": 123,
              "2020-10-23": 456
            }]
          }, {
            id: 5,
            gamename: '新增角色',
            "2020-10-21": 789,
            "2020-10-22": 123,
            "2020-10-23": 456,
            children: [{
              id: 31,
              gamename: '对比组1',
              "2020-10-21": 789,
              "2020-10-22": 123,
              "2020-10-23": 456
            }, {
              id: 32,
              gamename: '对比组2',
              "2020-10-21": 789,
              "2020-10-22": 123,
              "2020-10-23": 456
            }]
          }, {
            id: 4,
            gamename: '付费金额',
            "2020-10-21": 789,
            "2020-10-22": 123,
            "2020-10-23": 456,
            children: [{
              id: 31,
              gamename: '对比组1',
              "2020-10-21": 789,
              "2020-10-22": 123,
              "2020-10-23": 456
            }, {
              id: 32,
              gamename: '对比组2',
              "2020-10-21": 789,
              "2020-10-22": 123,
              "2020-10-23": 456
            }]
          }],
          tableData1: [{
            id: 1,
            date: '2016-05-02',
            name: '王小虎',
            address: '上海市普陀区金沙江路 1518 弄'
          }, {
            id: 2,
            date: '2016-05-04',
            name: '王小虎',
            address: '上海市普陀区金沙江路 1517 弄'
          }, {
            id: 3,
            date: '2016-05-01',
            name: '王小虎',
            address: '上海市普陀区金沙江路 1519 弄',
            hasChildren: true
          }, {
            id: 4,
            date: '2016-05-03',
            name: '王小虎',
            address: '上海市普陀区金沙江路 1516 弄'
          }]
        }
      },
      tableData4: {
        headers: [
          {
            label: "时间",
            property: "meiti",
            sortFlag: false,
            whidth: 95,
          },
          {
            label: "展示",
            property: "value1",
            sortFlag: false,
            whidth: 95,
            children: [
              {
                label: "A渠道/B渠道",
                property: "duibivalue1",
                sortFlag: false,
                whidth: 95,
              }
            ]
          },
          {
            label: "消耗",
            property: "value2",
            sortFlag: false,
            whidth: 95,
            children: [
              {
                label: "A渠道/B渠道",
                property: "duibivalue2",
                sortFlag: false,
                whidth: 95,
              }
            ]
          },
          {
            label: "新增",
            property: "value3",
            sortFlag: false,
            whidth: 95,
            children: [
              {
                label: "A渠道/B渠道",
                property: "duibivalue1",
                sortFlag: false,
                whidth: 95,
              }
            ]
          }],
        records: {
          result: [{
            "meiti": "2020-10-21 / 2020-10-22",
            "duibivalue1": "123 / 789",
            "duibivalue2": "123 / 789",
            "duibivalue3": "123 / 789",
          }, {
            "meiti": "2020-10-23 / 2020-10-24",
            "duibivalue1": "33354 / 797845",
            "duibivalue2": "33354 / 797845",
            "duibivalue3": "33354 / 797845",
          }, {
            "meiti": "2020-10-25 / 2020-10-26",
            "duibivalue1": "974 / 7942",
            "duibivalue2": "974 / 7942",
            "duibivalue3": "974 / 7942",
          },]
        }
      },

      tableData: {
        headers: [],
        records: {
          result: []
        }
      },
      total: 0,
      listQuery: {
        pageNo: 1,
        pageSize: 10
      },

      // 所有指标 
      recordsList: []
    }
  },
  created() {
    this.getGroup() // 查询数据维度
    this.getGameList() // 获取游戏列表
    this.getCommonChannel() // 获取公共渠道列表
    this.getTarget() // 查询数据筛选可选指标

    this.getList()
  },

  watch: {
    // 监听时间范围
    dateType(val) {
      // console.log(val)
      if (val == 'day' || val == 'all') {
        this.dayTimes = [new Date(new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 7)).Format("yyyy-MM-dd"), new Date(new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 1)).Format("yyyy-MM-dd")]
      } else {
        this.monthTimes = [new Date().Format("yyyy-MM"), new Date().Format("yyyy-MM")]
      }
    },

    // 监听分析维度 groupBy 变化
    groupBy() {
      this.appkeys = [] // 当前appkeys
      this.advertiserIds = [] // 当前媒体
      this.campaignIds = [] // 当前广告组
      this.adIds = [] // 当前广告计划
      this.creativeIds = [] // 当前广告创意
    },

    // 监听appks 变化
    appkeys() {
      this.advertiserIds = [] // 当前媒体
      this.campaignIds = [] // 当前广告组
      this.adIds = [] // 当前广告计划
      this.creativeIds = [] // 当前广告创意
    },

    // 监听媒体advertiserIds 变化
    advertiserIds() {
      this.campaignIds = [] // 当前广告组
      this.adIds = [] // 当前广告计划
      this.creativeIds = [] // 当前广告创意
    },

    // 监听当前广告组campaignIds变化
    campaignIds() {
      this.adIds = [] // 当前广告计划
      this.creativeIds = [] // 当前广告创意
    },

    // 监听当前广告计划 adIds 变化
    adIds() {
      this.creativeIds = [] // 当前广告创意
    },

    // 监听source 变化
    source(val) {
      if (val == 1) {
        this.onlyBdc = true
      } else {
        this.onlyBdc = false
      }
    }
  },

  methods: {
    bianjilie() { this.dialogVisible = true; },
    addduibitiaojian() {
      this.duibilist.push(JSON.parse(JSON.stringify(this.duibidata)))
      var tableheaderscopy = JSON.parse(JSON.stringify(this.tableheaders))
      for (var i = 0; i < this.duibilist.length; i++) {
        for (var j = 1; j < tableheaderscopy.length; j++) {
          tableheaderscopy[j].label += "/对比" + (i + 1)
        }
      }

      this.tableData = {
        headers: tableheaderscopy,
        records: {
          result: []
        }
      }
      //   this.total = 0


    },
    deleteduibitiaojian(e, index) {
      console.log(index)
      this.duibilist.splice(index, 1)

      var tableheaderscopy = JSON.parse(JSON.stringify(this.tableheaders))
      for (var i = 0; i < this.duibilist.length; i++) {
        for (var j = 1; j < tableheaderscopy.length; j++) {
          tableheaderscopy[j].label += "/对比" + (i + 1)
        }
      }

      this.tableData = {
        headers: tableheaderscopy,
        records: {
          result: []
        }
      }
      this.total = 0

    },

    // 查询数据维度
    getGroup() {
      find_groupBy().then(response => {
        if (response.code == 1) {
          this.groupByOptions = response.data
        }
      })
    },

    // 查询数据筛选可选指标
    getTarget() {
      find_target().then(response => {
        if (response.code == 1) {
          this.normOptions = response.data
        }
      })
    },

    // 获取游戏列表
    getGameList() {
      ajax_filterGame().then(response => {
        if (response.code == 1) {
          this.gameOptions = response.data
        }
      })
    },

    // 获取公共渠道列表
    getCommonChannel() {
      find_CommonChannel().then(response => {
        if (response.code == 1) {
          // this.mediaOptions = response.data
          this.mediaOptions = [
            {
              value: "1",
              label: "分包渠道",
              children: [{
                value: "11",
                label: "PC",
                children: [{
                  value: "111",
                  label: "4399微端",
                }]
              },
              {
                value: "12",
                label: "IOS正版",
                children: [{
                  value: "121",
                  label: "英雄互娱-IOS正版",
                }]
              },
              {
                value: "13",
                label: "安卓",
                children: [{
                  value: "131",
                  label: "B站",
                }, {
                  value: "132",
                  label: "VIVO",
                }, {
                  value: "133",
                  label: "英雄互娱-安卓",
                },]
              }]
            },
            {
              value: "2",
              label: "广告渠道",
              children: [{
                value: "21",
                label: "今日头条"
              },
              {
                value: "22",
                label: "广点通"
              },
              {
                value: "23",
                label: "阿里汇川"
              },
              {
                value: "24",
                label: "微动广告"
              }]
            }

          ]
        }
      })
    },

    // 查询筛选项
    getFilterData(e, code) {
      if (e) {
        let data = {}
        if (code == 'advertiser_id') { // 查询媒体账号列表
          data = {
            condition: code,
            appkeys: this.appkeys,
          }

        } else if (code == 'campaign_id') { // 广告组
          data = {
            condition: code,
            appkeys: this.appkeys,
            advertiserIds: this.advertiserIds
          }

        } else if (code == 'ad_id') { // 广告计划
          data = {
            condition: code,
            appkeys: this.appkeys,
            advertiserIds: this.advertiserIds,
            campaignIds: this.campaignIds
          }

        } else if (code == 'creative_id') { // 广告创意
          data = {
            condition: code,
            appkeys: this.appkeys,
            advertiserIds: this.advertiserIds,
            campaignIds: this.campaignIds,
            adIds: this.adIds
          }
        }

        find_condition(data).then(response => {
          if (response.code == 1) {
            if (code == 'advertiser_id') { // 查询媒体账号列表
              this.advertiserIdsOptions = response.data.slice(0, 200)
              this.advertiserIdsOptionsAll = response.data

            } else if (code == 'campaign_id') { // 广告组
              this.campaignIdsOptions = response.data.slice(0, 200)
              this.campaignIdsOptionsAll = response.data

            } else if (code == 'ad_id') { // 广告计划
              this.adIdsOptions = response.data.slice(0, 200)
              this.adIdsOptionsAll = response.data

            } else if (code == 'creative_id') { // 广告创意
              this.creativeIdsOptions = response.data.slice(0, 200)
              this.creativeIdsOptionsAll = response.data
            }
          }
        })
      }
    },

    // 优化 媒体账号 下拉列表数据
    filterAdvertiserIds(val) {
      this.advertiserIdsOptions = this.filterSelect(val, this.advertiserIdsOptionsAll)
    },

    // 优化 广告组 下拉列表数据
    filterCampaignIds(val) {
      this.campaignIdsOptions = this.filterSelect(val, this.campaignIdsOptionsAll)
    },

    // 优化 广告计划 下拉列表数据
    filterAdIds(val) {
      this.adIdsOptions = this.filterSelect(val, this.adIdsOptionsAll)
    },

    // 优化 广告创意 下拉列表数据
    filterCreativeIds(val) {
      this.creativeIdsOptions = this.filterSelect(val, this.creativeIdsOptionsAll)
    },

    filterSelect(val, listAll) {
      let list = []
      if (val) {
        list = listAll.filter(item => {
          return String(item['name']).indexOf(val) > -1
        })
      } else {
        list = listAll.slice(0, 200)
      }
      return list
    },


    // 获取表头
    getHeaderList() {
      const data = {
        dateType: this.dateType,
        startDate: this.dateType == 'day' || this.dateType == 'all' ? this.dayTimes[0] : this.monthTimes[0],
        endDate: this.dateType == 'day' || this.dateType == 'all' ? this.dayTimes[1] : this.monthTimes[1],
        groupBy: this.groupBy,
        appkeys: this.appkeys,
        medias: this.media,
        client_os: this.client_os,
        advertiserIds: this.advertiserIds,
        campaignIds: this.campaignIds,
        adIds: this.adIds,
        creativeIds: this.creativeIds,
        dataFilter: this.norm + this.symbol + this.normValue,
        queryType: this.queryType,
        types: this.types,
        //onlyBdc: this.onlyBdc,
        // notNull: this.notNull,
        pageNo: this.listQuery.pageNo,
        pageSize: this.listQuery.pageSize,
      }
      if (!((this.norm && this.symbol && this.normValue) || (!this.norm && !this.symbol && !this.normValue))) {
        this.$message({
          message: '请选择效果指标',
          type: 'error'
        });
        return
      }
      find_recordsPreloading(data).then(response => {
        if (response.code == 1) {
          this.tableheaders = response.data;
          this.tableData = {
            headers: response.data,
            records: {
              result: []
            }
          }
          this.total = 0
        }
      })
    },

    // 获取数据列表
    getList(sortProperty, sortType) {
      const data = {
        dateType: this.dateType,
        startDate: this.dateType == 'day' || this.dateType == 'all' ? this.dayTimes[0] : this.monthTimes[0],
        endDate: this.dateType == 'day' || this.dateType == 'all' ? this.dayTimes[1] : this.monthTimes[1],
        groupBy: this.groupBy,
        appkeys: this.appkeys,
        medias: this.media,
        client_os: this.client_os,
        advertiserIds: this.advertiserIds,
        campaignIds: this.campaignIds,
        adIds: this.adIds,
        creativeIds: this.creativeIds,
        dataFilter: this.norm + this.symbol + this.normValue,
        queryType: this.queryType,
        types: this.types,
        //    onlyBdc: this.onlyBdc,
        //    notNull: this.notNull,
        pageNo: this.listQuery.pageNo,
        pageSize: this.listQuery.pageSize,

        sortProperty: sortProperty, // 排序指标
        sortType: sortType, // 排序类型
      }

      if (!((this.norm && this.symbol && this.normValue) || (!this.norm && !this.symbol && !this.normValue))) {
        this.$message({
          message: '请选择效果指标',
          type: 'error'
        });
        return
      }

      this.listLoading = true
      find_records(data).then(response => {
        this.listLoading = false
        if (response.code == 1) {
          this.tableheaders = response.data.headers;
          this.tableData = response.data
          this.total = response.data.records.totalCount
        }
      })
    },

    // 查询
    handleFilter() {
      this.getList();
    },

    // 合计
    getSummaries(param) {
      var sums = [];
      var zongji = this.tableData.recordsSum;
      var theads = param.columns;
      for (var i = 0; i < theads.length; i++) {
        var istrue = false;
        for (var j in zongji) {
          if (theads[i].property == j) {
            sums.push(zongji[j])
            istrue = true;
          }
        }
        if (!istrue) {
          sums.push("")
        }
      }
      // console.log(sums)
      return sums;
    },

    // 编辑指标
    handleEditNorm() {
      this.$refs['norm'].init()
      this.getRecords()
    },

    // 查询指标
    getRecords() {
      find_recordsHeader().then(response => {
        this.$refs['norm'].loading = false
        if (response.code == 1) {
          // console.log(response)
          const data = JSON.parse(JSON.stringify(response.data))
          data.forEach(arr => {
            let nums = 0;
            arr.children.forEach(item => {
              if (item.checked) {
                nums++
              }
            })

            if (nums == arr.children.length) {
              arr.checked = true
            } else {
              arr.checked = false
            }
          })

          // this.$refs['norm'].sourceData = data
          this.recordsList = data
        }
      })
    },

    // 确定编辑指标
    quedingshaixuan(list) {
      // console.log('====',list)
      const ids = []
      list.forEach(item => {
        if (item.children && item.children.length > 0) {
          item.children.forEach(item => {
            if (item.checked) {
              ids.push(item.id)
            }
          })
        }
      })

      const data = {
        ids: ids
      }
      // console.log(ids)
      sync_headerData(data).then(response => {
        this.$refs['norm'].dialogLoading = false
        if (response.code == 1) {
          this.$refs['norm'].dialogTableVisible = false
          this.getList();
        }
      })
    },


    // 自定义表头宽度
    labelHead(h, { column, $index }) {
      if (column.property == 'daytime' || column.property == 'monthtime') {
        column.minWidth = 95
      } else if (column.property == 'advertiserName' || column.property == 'gameName') {
        column.minWidth = 120
      } else if (column.property == 'adName' || column.property == 'creativeName') {
        column.minWidth = 220
      } else if (column.property.indexOf('ltv') > -1 || column.property.indexOf('remain') > -1 || column.property.indexOf('roi') > -1) {
        column.minWidth = 85
      } else {
        let len = column.label.length
        let size = 0 //每个字大小，其实是每个字的比例值，大概会比字体大小差不多大一点，

        if (len == 2) {
          size = 45
        } else if (len == 3) {
          size = 28
        } else if (len >= 4 && len <= 6) {
          size = 22
        } else {
          size = 15
        }
        column.minWidth = size * len //字大小乘个数即长度 ,注意不要加px像素，这里minWidth只是一个比例值，不是真正的长度
      }

      //然后将列标题放在一个div块中，注意块的宽度一定要100%，否则表格显示不完全
      return h('div', { class: 'table-head', style: { width: '100%' } }, [column.label])

    },

    // 监听排序变化
    handleAgeSortChange(e) {
      console.log(e);
      if (e.order) {
        const order = e.order == 'ascending' ? 'asc' : 'desc'
        // this.caseTable.sort(sortKeys(e.prop, order))
        this.getList(e.prop, order)
      } else {
        this.getList()
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.filter-container {
  // display: flex;
  // flex-flow: row wrap;
  .filter-data {
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    margin: 5px 10px 5px;
  }
  .label {
    min-width: 77px;
    font-size: 15px;
    margin-right: 3px;
    color: #7b7b7b;
  }

  ::v-deep .el-select__tags {
    .el-tag {
      max-width: 74%;
      overflow: hidden;
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: center;
      .el-select__tags-text {
        width: 100%;
        overflow: hidden;
      }
    }
    .el-select__input {
      margin-left: 2px;
    }
  }

  ::v-deep .el-cascader__tags {
    .el-tag {
      max-width: 60%;
    }
    .el-cascader__search-input {
      min-width: 10%;
      margin: 2px 0 2px 2px;
    }
  }
}

.box-card {
  ::v-deep .el-card__header {
    padding: 6px 20px !important;
  }
  ::v-deep .el-card__body {
    padding: 0;
  }
}

.checkbox-table-headers .el-checkbox {
  min-width: 150px;
}

.grayTableTile ::v-deep .el-table__body-wrapper {
  z-index: 1;
}

.dataPicker {
  position: relative;
  ::v-deep .el-picker-panel {
    position: absolute;
    top: 32px;
    z-index: 99;
  }
}

.card-box {
  .item {
    margin-bottom: 18px;
  }
  .text {
    font-size: 14px;
  }
  ::v-deep .el-card__body {
    padding: 10px;
  }
}

// .grayTableTile{
//     ::v-deep .table-head{
//         font-size:14px!important;//设置固定的字体大小
//     }
// }
</style>
